/* oxlint-disable react-compiler/react-compiler */
// https://www.notion.so/doss-com/React-Compiler-Warning-Fixes-Log-34cf16c5ee36803c9817d41bdec112e1?source=copy_link
import { Stack } from '@mui/material'
import { useEffect } from 'react'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { DossSignalType, useDossSignals } from '../../common/hooks/useDossSignals'
import { Button } from '../ui/atoms/button/Button'
import { Modal } from '../ui/molecules/modal/Modal'

interface RecordDuplicateSaveAndDuplicateDialogProps {
  openDialog: boolean
  handleCloseSaveAndDuplicate: () => void
  handleDuplicateRecord: (rowId: string) => void
}

export function RecordDuplicateSaveAndDuplicateDialog({
  openDialog,
  handleCloseSaveAndDuplicate,
  handleDuplicateRecord,
}: RecordDuplicateSaveAndDuplicateDialogProps) {
  const { dispatch, subscribe, unsubscribe } = useDossSignals()
  const { t } = useTypedTranslation()
  useEffect(() => {
    const subscriptionId = subscribe(
      DossSignalType.RECORD_FORM_SAVE_AND_DUPLICATE_SAVE_COMPLETED,
      async (tableRowId: string) => {
        handleDuplicateRecord(tableRowId)
      },
    )
    return () => {
      unsubscribe(subscriptionId)
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Need to subscribe to this signal on initial page load

  const handleSaveAndDuplicate = () => {
    dispatch(DossSignalType.RECORD_FORM_SAVE_AND_DUPLICATE_SUBMITTED)
    handleCloseSaveAndDuplicate()
  }

  return (
    <Modal
      actions={
        <Button onClick={handleSaveAndDuplicate} size="small" variant="secondary">
          {t('record.save_and_duplicate')}
        </Button>
      }
      onClose={handleCloseSaveAndDuplicate}
      open={openDialog}
      title="Save changes and duplicate record"
    >
      <Stack gap={1}>
        {t('record.unsaved_changes')}
        <br />
        {t('record.save_and_duplicate_warning')}
      </Stack>
    </Modal>
  )
}
